import { eventsGuestOperationsRoutes } from '@/app/modules/events/guestOperations/eventsGuestOperations.routes';

const EventsRoutes = [...eventsGuestOperationsRoutes];

export default EventsRoutes;
